<div class="auth">
  @if (!isEmailSent) {
    <div class="login-form">
      @if (forgotPasswordFormGroup) {
        <form [formGroup]="forgotPasswordFormGroup">
          <h3>{{ 'auth.enterEmail' | translate }}</h3>
          <div class="form-group">
            <label class="required">{{ 'auth.email' | translate }}</label>
            <dx-text-box valueChangeEvent="change keyup" formControlName="email"></dx-text-box>
            @if (displayRequiredError(forgotPasswordFormGroup.get('email'))) {
              <div class="ng-invalid-comment">
                {{ 'validation.required' | translate }}
              </div>
            }
            @if (
              forgotPasswordFormGroup.get('email')?.dirty &&
              forgotPasswordFormGroup.get('email')?.hasError('email')
            ) {
              <div class="ng-invalid-comment">
                {{ 'validation.validEmail' | translate }}
              </div>
            }
            @if (displayPatternError(forgotPasswordFormGroup?.get('email'))) {
              <div class="ng-invalid-comment">
                {{ 'validation.notAllowPlusSignInEmail' | translate }}
              </div>
            }
          </div>
          <div class="submit">
            <dx-button
              class="btn-xl btn-rounded"
              stylingMode="contained"
              type="default"
              text="{{ 'auth.sendResetLink' | translate }}"
              (onClick)="onForgotPasswordSubmit()">
            </dx-button>
          </div>
        </form>
      }
    </div>
  }
  @if (isEmailSent) {
    <div class="login-form">
      @if (verificationCodeFormGroup) {
        <form [formGroup]="verificationCodeFormGroup">
          <h3>{{ 'auth.enterCode' | translate }}</h3>
          <div class="acenter">
            <img src="/assets/images/sent-success.png" class="sent-success" />
          </div>
          <div class="desc">
            {{ 'auth.codeEmailSent' | translate }}
            {{ forgotPasswordFormGroup.get('email').value }}
          </div>
          <div class="form-group">
            <dx-text-box
              valueChangeEvent="change keyup"
              [maxLength]="6"
              formControlName="verificationCode"
              class="acenter">
            </dx-text-box>
            @if (displayRequiredError(verificationCodeFormGroup.get('verificationCode'))) {
              <div class="ng-invalid-comment">
                {{ 'validation.required' | translate }}
              </div>
            }
            <div class="small-desc">
              {{ 'auth.codeIsCaseSensitive' | translate }}
            </div>
          </div>
          <div class="submit">
            <dx-button
              class="btn-xl btn-rounded"
              stylingMode="contained"
              type="default"
              text="{{ 'auth.verify' | translate }}"
              (onClick)="onVerificationCodeSubmit()">
            </dx-button>
          </div>
        </form>
      }
    </div>
  }
  <div class="form-footer">
    <a
      href="javascript:void(0)"
      class="simple-btn simple-btn-sm simple-btn-rounded simple-btn-dark-line"
      (click)="onBack()">
      <i class="icon-left-arrow"></i>
      <span>{{ 'general.back' | translate }}</span>
    </a>
  </div>
</div>
